import request from '@/config/axios'
import type { FirmReceivableSummaryVO } from '@/api/lawyer/firmFee'

export interface FirmReportQueryVO {
  teamId?: number
  lawyerId?: number
  dateBegin?: string
  dateEnd?: string
  overdueOnly?: boolean
}

export interface FirmMatterStatsVO {
  total: number
  active: number
  closed: number
  byCaseType: { caseType: string; count: number }[]
}

export interface FirmLawyerPerformanceVO {
  lawyerId: number
  lawyerName?: string
  revenue: number
  received: number
  matterCount: number
  timeMinutes: number
}

export interface FirmCustomerContributionVO {
  customerId: number
  customerName?: string
  totalAmount: number
  receivedAmount: number
  outstandingAmount: number
}

export const FirmReportApi = {
  matterStats: (params?: FirmReportQueryVO) =>
    request.get({ url: '/lawyer/firm/report/matter-stats', params }) as Promise<FirmMatterStatsVO>,
  lawyerPerformance: (params?: FirmReportQueryVO) =>
    request.get({ url: '/lawyer/firm/report/lawyer-performance', params }) as Promise<FirmLawyerPerformanceVO[]>,
  receivableSummary: (params?: FirmReportQueryVO) =>
    request.get({ url: '/lawyer/firm/report/receivable-summary', params }) as Promise<FirmReceivableSummaryVO>,
  customerContribution: (params?: FirmReportQueryVO) =>
    request.get({ url: '/lawyer/firm/report/customer-contribution', params }) as Promise<FirmCustomerContributionVO[]>,
  exportLawyerPerformance: (params?: FirmReportQueryVO) =>
    request.download({ url: '/lawyer/firm/report/export', params: { ...params, type: 'LAWYER_PERFORMANCE' } })
}
